<template lang="pug">
  div.lmm-content-body-padded
    b-container(fluid)
      b-row
        b-col.page-wrap(cols="12")
          div(slot="header").d-flex.justify-content-between.page-header
            b-container.d-flex.justify-content-between(fluid)
              div
                span.page-title {{$t('remote.remote.title')}} {{$t('history')}}
                b-button(variant="link", size="sm", style="padding: 0.25rem 0.7rem;", target="_blank", href="https://linkmemine.co.kr/faq/p/manager_guide_topic_07.php")
                  //icon(name="bookmark", style="margin:0 4px 0 2px;")
                  span {{$t('tutorial-statistics')}}
          b-container(fluid)
            b-row
              b-card.w-100(no-body)
                b-container(slot="header", fluid)
                  b-row
                    b-col(cols="2")
                      datepicker(
                        :value="range.start",
                        :bootstrap-styling="true",
                        format="yyyy-MM-dd",
                        :language="range.lang",
                        @selected="startDateChanged")
                    b-col(cols="2")
                      datepicker(
                        :value="range.end",
                        :bootstrap-styling="true",
                        format="yyyy-MM-dd",
                        :language="range.lang",
                        :disabledDates="range.disabledDates",
                        @selected="endDateChanged")
                    b-col(cols="2")
                      b-form-select(v-model="filter.key", :options="filter.options", size="sm", @change="keyChangeHandler")
                    b-col(cols="2")
                      b-form-input(v-model="filter.value", size="sm", @keydown.enter="tableRefresh")
                    b-col(cols="2")
                      b-button(size="sm", @click="tableRefresh") {{$t('search')}}
                    b-col.ml-auto.text-right(cols="2")
                      b-button(size="sm", variant="info", :disabled="!excelLoaded", @click="downloadExcel")
                        b-spinner(style="width: 16px; height: 16px; margin-right: 5px;" v-if="isExcelLoading")  <!-- 스피너 추가 -->
                        | EXCEL
                b-table(
                  ref="dataTable",
                  :fields="fields",
                  :items="items",
                  :current-page="page.current",
                  :per-page="page.per",
                  :empty-text="$t('no-content')",
                  tbody-class="lmm-table-body",
                  show-empty)
                  template(slot="HEAD_reg_mail", slot-scope="data")
                    | {{$t('ID')}}
                  template(slot="HEAD_alias", slot-scope="data")
                    | {{$t('device')}}
                  template(slot="HEAD_host_ip", slot-scope="data")
                    | {{$t('device')}} IP
                  template(slot="HEAD_host_os", slot-scope="data")
                    | {{$t('device')}} OS
                  template(slot="HEAD_viewer_ip", slot-scope="data")
                    | {{$t('user')}} IP
                  template(slot="HEAD_viewer_os", slot-scope="data")
                    | {{$t('user')}} OS
                  template(slot="HEAD_start_time", slot-scope="data")
                    | {{$t('start_time')}}
                  template(slot="HEAD_end_time", slot-scope="data")
                    | {{$t('end_time')}}
                  template(v-slot:cell(host_ip)="data")
                    | {{data.item.host_public_ip}}
                    br
                    | {{data.item.host_private_ip}}
                  template(v-slot:cell(viewer_ip)="data")
                    | {{data.item.viewer_public_ip}}
                    br
                    | {{data.item.viewer_private_ip}}
                  template(v-slot:cell(host_os)="data")
                    //icon(:name="data.item.host_os_id | nameOS")
                    span {{data.item.host_os_id | remoteOS}}
                  template(v-slot:cell(viewer_os)="data")
                    //icon(:name="data.item.viewer_os_id | nameOS")
                    span {{data.item.host_os_id | remoteOS}}
                  template(v-slot:cell(start_time)="data")
                    //- | {{data.item.start_time | moment('add', AppState.Info.timezoneOffset, AppState.Info.dateFmt + ' HH:mm:ss')}}
                    | {{data.item.start_time| moment('add', AppState.Info.timezoneOffsetLocal, 'YY/MM/DD HH:mm')}}
                  template(v-slot:cell(end_time)="data")
                    //- span(v-if="data.item.end_time !== 'None'") {{data.item.end_time | moment('add', AppState.Info.timezoneOffset, AppState.Info.dateFmt + ' HH:mm:ss')}}
                    span(v-if="data.item.end_time !== 'None'") {{data.item.end_time | moment('add', AppState.Info.timezoneOffsetLocal, 'YY/MM/DD HH:mm')}}
                  template(v-slot:cell(security)="data")
                    icon(name="check")
                div.d-flex.justify-content-between(slot="footer")
                  div
                    b-form-select(
                      size="sm",
                      v-model="page.per",
                      :options="page.perOptions")
                  b-pagination(
                    size="sm",
                    :total-rows="page.total",
                    :per-page="page.per",
                    v-model="page.current",
                    class="my-0 float-right"
                  )
</template>

<script>
import moment from 'moment'
import {getCurrentLanguage} from '@/i18n'
import * as datePickerLocale from 'vuejs-datepicker/dist/locale'
import Datepicker from 'vuejs-datepicker'
import {AnalysticAPI} from '../../api'

export default {
  name: 'log-remote-component',
  components: { Datepicker },
  methods: {
    downloadExcel () {
      if (this.excelLoaded && this.excelLink) {
        const timestamp = new Date().getTime()
        location.href = `${this.excelLink}?v=${timestamp}`
      }
    },
    keyChangeHandler () {
      this.filter.value = ''
    },
    startDateChanged (date) {
      this.range.start = date
      this.range.disabledDates.to = date
    },
    endDateChanged (date) {
      this.range.end = date
    },
    tableRefresh () {
      this.excelLoaded = false
      this.isExcelLoading = true
      this.page.current = 1
      this.$refs.dataTable.refresh()
    },
    items (ctx) {
      let params = {
        by: 'create_time',
        start_date: moment(this.range.start).format('YYYY-MM-DD'),
        end_date: moment(this.range.end).format('YYYY-MM-DD'),
        limit: ctx.perPage,
        offset: ctx.perPage * (ctx.currentPage - 1),
        order: 'desc',
        export_id: 'remoteHistoryTable'
      }
      if (this.filter.value) {
        params.search_key = this.filter.key
        params.search_value = this.filter.value
      }
      AnalysticAPI.excel.post('', params)
        .then((resp) => {
          if (!resp.data.objects.length) {
            const downloadUrl = resp.data.objects.download_url
            const fileName = resp.data.objects.file_name
            if (process.env.VUE_APP_SCI) {
              this.excelLink = `${this.AppState.Path.origin}:8443${downloadUrl}/${fileName}`
            } else {
              this.excelLink = `${this.AppState.Path.origin}${downloadUrl}/${fileName}`
            }
            this.excelLoaded = true
          } else {
            this.excelLink = null
            this.excelLoaded = false
          }
        })
        .catch((error) => {
          this.$awn.warning(this.$t('excel_processing_delayed'))
        })
        .finally(() => {
          this.isExcelLoading = false
        })
      return AnalysticAPI.history.get('remote', {params})
        .then(resp => {
          this.page.total = resp.data.meta.total_count
          return resp.data.objects
        })
    }
  },
  data () {
    let disabledDateInit = new Date()
    disabledDateInit.setDate(-1)
    return {
      excelLoaded: false,
      excelLink: null,
      isExcelLoading: true,
      range: {
        start: (new Date().setDate(-1)),
        end: new Date(),
        disabledDates: { to: disabledDateInit },
        lang: datePickerLocale[getCurrentLanguage()]
      },
      fields: [
        { key: 'reg_mail', label: 'ID' },
        { key: 'alias', label: this.$t('device') },
        {
          key: 'host_ip',
          label: this.$t('host') + ' IP',
          tdClass: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'host_os',
          label: this.$t('host') + ' OS',
          tdClass: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'viewer_ip',
          label: this.$t('viewer') + ' IP',
          tdClass: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'viewer_os',
          label: this.$t('viewer') + ' OS',
          tdClass: 'text-center',
          thClass: 'text-center'
        },
        { key: 'start_time', label: this.$t('start_time') },
        { key: 'end_time', label: this.$t('end_time') },
        { key: 'security',
          label: this.$t('security-access-title'),
          tdClass: 'text-center',
          thClass: 'text-center'
        }
      ],
      page: {
        total: 0,
        current: 1,
        per: 10,
        perOptions: [
          { value: 5, text: '5' },
          { value: 10, text: '10' },
          { value: 15, text: '15' },
          { value: 20, text: '20' }
        ]
      },
      filter: {
        key: 'alias',
        value: '',
        options: [
          { text: this.$t('device'), value: 'alias' },
          { text: this.$t('ID'), value: 'e-mail' }
        ]
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.lmm-content-body-padded {
  padding: 0;
  margin: 0;
}

.row, .col, .container-fluid, .container {
  margin: 0;
  padding: 0;
}

.page-wrap {
  padding: 1rem 1.5rem;
}

.page-header {
  padding: 0 1.5rem 0 1.5rem;
  margin-bottom: 0.5rem;
}

.card {
  border-radius: 0;
  .card-body {
    padding: 0;
  }
}

::v-deep .form-control, .custom-select {
  display: flex;
  background-color: #FFFFFF !important;
  border: 1px solid #6F6F6F !important;
  border-radius: 0;
  height: 1.75rem;
  align-items: center;
  text-align: left !important;
}

::v-deep .b-table {
  tr, td, th {
    padding: 0.5rem 0 0.5rem 1rem;
    position: relative;
    font-weight: 400;

  }
  th:nth-child(1), td:nth-child(1) {
    padding-left: 1rem;
  }
  td {
    color: #6F6F6F;
  }
}

.btn-secondary {
  color: black !important;
  font-weight: 400;
}

.btn-secondary:hover {
  color: black !important;
  background-color: #F7F7F7 !important;
  border: 1px solid #9C9C9C !important;
  font-weight: 400;
}

.btn-secondary:active {
  color: black !important;
  background-color: #CBCBCB !important;
  border: 1px solid #9C9C9C !important;
  font-weight: 400;
}
</style>
